var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertscontributingtotickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4321 9.60317V6.64835",
    stroke: "#5DA3E9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4321 12.1886V12.2847",
    stroke: "#5DA3E9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21498 3.69351C7.7559 2.70857 9.10819 2.70857 9.64911 3.69351L14.5174 12.558C15.0583 13.5429 14.3822 14.7741 13.3003 14.7741H3.56381C2.48198 14.7741 1.80583 13.5429 2.34675 12.558L7.21498 3.69351Z",
    stroke: "#5DA3E9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 23.7163C14.8006 23.7163 14.641 23.8892 14.641 24.1028C14.641 24.3164 14.8007 24.4895 14.9971 24.4895C15.1938 24.4895 15.3531 24.3164 15.3531 24.1028C15.3531 23.8892 15.1938 23.7163 14.9971 23.7163Z",
    fill: "#5DA3E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 22.2713C14.8006 22.2713 14.641 22.4444 14.641 22.658C14.641 22.8714 14.8007 23.0445 14.9971 23.0445C15.1938 23.0445 15.3531 22.8714 15.3531 22.658C15.3531 22.4444 15.1938 22.2713 14.9971 22.2713Z",
    fill: "#5DA3E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3531 17.6214H15.3531H15.2878H14.641H12.135H11.4881V18.3238V25.5474V26.25H12.135H14.641H15.2879H15.3531H24.3531H25V25.5474V18.3238V17.6214H24.3531ZM24.3531 25.5474H15.3531C15.3531 25.3338 15.1937 25.1609 14.997 25.1609C14.8006 25.1609 14.641 25.3338 14.641 25.5474H12.135V18.3238H14.641C14.641 18.5374 14.8006 18.7102 14.997 18.7102C15.1937 18.7102 15.3531 18.5374 15.3531 18.3238H24.3531L24.3531 25.5474Z",
    fill: "#5DA3E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 20.8267C14.8006 20.8267 14.641 20.9998 14.641 21.2134C14.641 21.4267 14.8007 21.5999 14.9971 21.5999C15.1938 21.5999 15.3531 21.4267 15.3531 21.2134C15.3531 20.9998 15.1938 20.8267 14.9971 20.8267Z",
    fill: "#5DA3E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 19.382C14.8006 19.382 14.641 19.5548 14.641 19.7685C14.641 19.9821 14.8007 20.1552 14.9971 20.1552C15.1938 20.1552 15.3531 19.9821 15.3531 19.7685C15.3531 19.5548 15.1938 19.382 14.9971 19.382Z",
    fill: "#5DA3E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6076 16.5531L20.5184 11.8911L23.0305 16.9188H23.7661L21.0868 11.5557L20.7785 10.9386L20.2097 11.2733L12.2995 15.9358L12.2422 15.9694L11.6736 16.3043L9.47101 17.6027L8.90244 17.9378L9.21096 18.5554L10.8415 21.8188V20.3458L9.77956 18.2203L10.8415 17.5941L12.6076 16.5531Z",
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertscontributingtotickets);
export default __webpack_public_path__ + "static/media/Alerts contributing to tickets.8ca2d657f3a0059383f7f9673239cee1.svg";
export { ForwardRef as ReactComponent };